// extracted by mini-css-extract-plugin
export var Hero_image = "Hero-module--Hero_image--WDQAE";
export var Hero_image_action = "Hero-module--Hero_image_action--0w-BI";